var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React from "react";
export default ((_ref) => {
  let {
    styles = {}
  } = _ref,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement(
    "svg",
    _extends({ width: "24", height: "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M9 9V6H15V9C15 10.6569 13.6569 12 12 12C10.3431 12 9 10.6569 9 9ZM16 9V6V4C16 2.89543 15.1046 2 14 2H10C8.89543 2 8 2.89543 8 4V6V9C8 11.2091 9.79086 13 12 13C14.2091 13 16 11.2091 16 9ZM9 21H5V18C5 16.3431 6.34315 15 8 15H9V21ZM10 21H19V18C19 16.3431 17.6569 15 16 15H10V21ZM16 14H8C5.79086 14 4 15.7909 4 18V22H20V18C20 15.7909 18.2091 14 16 14ZM15 5H9V4C9 3.44772 9.44772 3 10 3H14C14.5523 3 15 3.44772 15 4V5ZM13 16V17H11V16H13ZM13 19V18H11V19H13Z", fill: "#303030" })
  );
});